export const exampleRoutes = [
  // TODO ALE - Eliminar esta ruta de ejemplo y los componentes mock
  {
    path: `/lf-tabs`,
    name: 'tabs',
    component: () => import('@/views/LfTabsExample/LfTabsExampleView.vue'),
    meta: {
      requiresAuth: false,
      title: 'tabs'
    }
  },
  {
    path: '/example/filemanager',
    name: 'filemanager',
    component: () => import('@/views/examples/FileManager/FileManagerView.vue'),
    meta: {
      requiresAuth: true,
      title: 'fileManager'
    },
  },
  {
    path: `/examples/grid-simple`,
    component: () => import('@/views/examples/grids/LfGridSimpleView.vue'),
    meta: {
      requiresAuth: true,
    }
  },
  {
    path: `/examples/grid-ssp`,
    component: () => import('@/views/examples/grids/LfGridSSPView.vue'),
    meta: {
      requiresAuth: true,
    }
  }
]
